import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
 
import { GeocodingModel } from '../models/location.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
 
@Injectable({
  providedIn: 'root',
})

export class ConsumerPlacesResolverService implements Resolve<any> {

  constructor(private dataService: DataService, private auth: AuthenticationService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GeocodingModel[]>{
    const user = await this.auth.getUser();
    const id = route.paramMap.get("profileId") || user.uid;
    const item = await firstValueFrom(this.dataService.getConsumerPlaces(id))
    console.log(item);
    return item;
  }
}